import "../Static Files/styles/Navbar And Footer/navbarAndFooter.css";
import logo from "../Static Files/Images/HomePage/Logo Transparent.png";
import phone24 from "../Static Files/Images/HomePage/Telephone 24x24.png";
import ruFlag from "../Static Files/Images/HomePage/Ru@3x.png";
import azFlag from "../Static Files/Images/HomePage/azflag.png";
import enFlag from "../Static Files/Images/HomePage/Gb@3x.png";
import instagramicon from "../Static Files/Images/HomePage/instagram b 128x128.png";
import blogicon from "../Static Files/Images/HomePage/Blog 128x128.png";
import { useEffect, useState } from "react";
import ArrowIcon from "./arrowIcon";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import translation from "../locales";

import renticon from "../Static Files/Images/rentacar/renticon.png";

const Navbar = () => {
  const [mediaOpen, setMediaOpen] = useState(false);
  const [languageOpen, setLanguageOpen] = useState(false);
  const [servicesOpen, setServiceOpen] = useState(false);
  const [burgerOpen, setBurgerOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const lang = location.pathname.split("/")[1];
  const currentLang = translation[lang] ? lang : "az";

  const changeLanguage = (newLang) => {
    const newPath = location.pathname.replace(
      `/${currentLang}/`,
      `/${newLang}/`
    );
    navigate(newPath);
    setLanguageOpen(false);
  };

  return (
    <>
      <header>
        <nav id="navbar">
          <div className="left-menu-responsive">
            {/* Burger Button */}
            <button className="menu-button" onClick={() => setBurgerOpen(true)}>
              <i className="fa-solid fa-bars"></i>
            </button>
            <ul className="brand brand-responsive">
              <li>
                <img src={logo} alt="Logo" />
                <NavLink to={`/${currentLang}/`}>
                  <h3 className="first-text">Joyful</h3>
                  <h3 className="second-text">Travel</h3>
                </NavLink>
              </li>
            </ul>
          </div>
          <ul className="brand brand-site">
            <li>
              <img src={logo} alt="Logo" />
              <NavLink to={`/${currentLang}/`}>
                <h3 className="first-text">Joyful</h3>
                <h3 className="second-text">Travel</h3>
              </NavLink>
            </li>
          </ul>
          <ul className="left-menu">
            <li>
              <NavLink
                style={{ display: "flex", alignItems: "center", gap: "0.5vw" }}
                onClick={() => setServiceOpen(!servicesOpen)}
              >
                {translation[currentLang].navservices} <ArrowIcon />
              </NavLink>
            </li>
            {servicesOpen && (
              <ul className="dropdown-menu-service">
                <li>
                  <i style={{fontSize:"1vw"}} class="fa-solid fa-list"></i>
                  <NavLink onClick={() => setServiceOpen(false)} to={`/${currentLang}/alltours`}>
                    {translation[currentLang].navtours}
                  </NavLink>
                </li>
                <li>
                  <img src={renticon} alt="icon" />
                  <NavLink onClick={() => setServiceOpen(false)} to={`/${currentLang}/rent`}>Rent a car</NavLink>
                </li>
              </ul>
            )}
            <li>
              <NavLink to={`/${currentLang}/aboutus`}>
                {translation[currentLang].navaboutus}
              </NavLink>
            </li>
            <li>
              <NavLink to={`/${currentLang}/contact`}>
                {translation[currentLang].navcontact}
              </NavLink>
            </li>
          </ul>
          <ul className="right-menu">
            <li className="dropdown">
              <button
                className="media-button"
                onClick={() => setMediaOpen(!mediaOpen)}
              >
                Media <ArrowIcon />
              </button>
              {mediaOpen && (
                <ul className="dropdown-menu">
                  <li>
                    <img src={instagramicon} alt="icon" />
                    <NavLink
                      onClick={() => setMediaOpen(false)}
                      to={`/${currentLang}/posts`}
                    >
                      Instagram
                    </NavLink>
                  </li>
                  <li
                    onClick={() =>
                      window.scrollTo({
                        top: 2500,
                        left: 0,
                        behavior: "smooth",
                      })
                    }
                  >
                    <img src={blogicon} alt="icon" />
                    <NavLink>Blog</NavLink>
                  </li>
                </ul>
              )}
            </li>
            <li className="dropdown">
              <button
                className="language-button"
                onClick={() => setLanguageOpen(!languageOpen)}
              >
                <img src={currentLang === "az" ? azFlag : enFlag} alt="flag" />
                {currentLang === "az" ? "AZ" : "EN"}
              </button>
              {languageOpen && (
                <ul className="dropdown-menu">
                  <li>
                    <img src={azFlag} />
                    <a onClick={() => changeLanguage("az")}>AZ</a>
                  </li>
                  <li>
                    <img src={enFlag} />
                    <a onClick={() => changeLanguage("en")}>EN</a>
                  </li>
                </ul>
              )}
            </li>
            <li>
              <a className="phone-link" href="tel:+9940555074499">
                <img src={phone24} alt="phone" /> (+99455) 507 44 99
              </a>
            </li>
          </ul>
        </nav>
      </header>

      {/* Burger Menu Overlay (mobil görünüş üçün) */}
      {burgerOpen && (
        <div className="burger-overlay">
          <button className="close-button" onClick={() => setBurgerOpen(false)}>
            <i className="fa-solid fa-xmark"></i>
          </button>
          <ul className="lang-ul">
            <li className="dropdown lang-dropdown">
              <button
                className="language-button"
                onClick={() => setLanguageOpen(!languageOpen)}
              >
                <img src={currentLang === "az" ? azFlag : enFlag} alt="flag" />
                {currentLang === "az" ? "AZ" : "EN"}
              </button>
              {languageOpen && (
                <ul className="resp-dropdown">
                  <li>
                    <img src={azFlag} />
                    <a onClick={() => changeLanguage("az")}>AZ</a>
                  </li>
                  <li>
                    <img src={enFlag} />
                    <a onClick={() => changeLanguage("en")}>EN</a>
                  </li>
                </ul>
              )}
            </li>
          </ul>
          <ul className="burger-menu">
            <li>
              <NavLink
                onClick={() => {
                  setBurgerOpen(false);
                }}
                to={`/${currentLang}/alltours`}
              >
                {translation[currentLang].navtours}
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={() => {
                  setBurgerOpen(false);
                }}
                to={`/${currentLang}/aboutus`}
              >
                {translation[currentLang].navaboutus}
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={() => {
                  setBurgerOpen(false);
                }}
                to={`/${currentLang}/contact`}
              >
                {translation[currentLang].navcontact}
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={() => {
                  setBurgerOpen(false);
                }}
                to={`/${currentLang}/rent`}
              >
                Rent a car
              </NavLink>
            </li>
            <li>
              <NavLink
                onClick={() => {
                  setBurgerOpen(false);
                }}
                to={`/${currentLang}/posts`}
              >
                Instagram
              </NavLink>
            </li>
          </ul>
        </div>
      )}
    </>
  );
};

export default Navbar;
